<div class="flex flex-col md:flex-row md:gap-4 portal-section-grid">

  <mat-card class="md:w-1/2">
    <mat-card-header>
      <mat-card-title>
        <span class="font-semibold text-xl">Manage Reference Documents</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <document [entityId]="0"
                [entityType]="hospitalReference"
                [statuses]="[]"
                [types]="referenceTypes"
                [editable]="true"
                [isReference]="true">
      </document>
    </mat-card-content>
  </mat-card>

  <div class="flex flex-col gap-4 md:w-1/2">
    <!-- <hospital-reports></hospital-reports> -->

    <div class="flex flex-row gap-6 items-center">
      <span>Upload Licenses</span>
      <input type="file" style="display: none;" (change)="uploadData($event, false)" #hospitalUpload />
      <div class="flex flex-row gap-2">
        <div class="file-upload">
          <button mat-button color="primary" class="upload-btn" (click)="hospitalUpload.click()"
                  matTooltip="Upload Licenses" matTooltipShowDelay="500" matTooltipHideDelay="200">
            Upload
            <mat-icon>upload</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="flex flex-row gap-6 items-center">
      <span>Upload SICF Data</span>
      <input type="file" style="display: none;" (change)="uploadData($event, true)" #sicfUpload />
      <div class="flex flex-row gap-2">
        <div class="file-upload">
          <button mat-button color="primary" class="upload-btn" (click)="sicfUpload.click()"
                  matTooltip="Upload SICF Data" matTooltipShowDelay="500" matTooltipHideDelay="200">
            Upload
            <mat-icon>upload</mat-icon>
          </button>
        </div>
      </div>
    </div>

  </div>

</div>
